export default defineNuxtRouteMiddleware((to) => {
  const { path, query, hash } = to

  // 末尾にスラッシュがない場合は追加
  if (path.endsWith('/')) return
  const nextPath = path + '/'
  const nextRoute = { path: nextPath, query, hash }
  return navigateTo(nextRoute, { redirectCode: 301 })
})
